import { useState } from 'react';

import socket from '@/services/socket';

export const useLessonCount = () => {
  const [lessonCount, setLessonCount] = useState<number>(0);

  socket.on('learner-user-count-lesson', (count: number) => {
    setLessonCount(count);
  });

  socket.on('learner-user-count-updated', (count: number) => {
    setLessonCount(count);
  });

  return {
    lessonCount
  };
};
